export default __webpack_public_path__ + "static/media/rocket.b6154222.png";